import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules';

const testimonials = [
    {
        quote:
            'Operating a successful business that can be used as a vehicle for positive impact has been the mission of Patagonia since the beginning. Rens has set out to help other organizations chart a path to doing the same…',
        name: 'Ryan Gellert',
        role: 'CEO, Patagonia',
    },
    {
        quote: 'Rens’ creativity & focus on results facilitated unprecedented progress in G20 complicated global challenges, and he also led the design & thought leadership around the AI strategy for the Ministry on a global stage.',
        name: 'Abdullatif Aljabr',
        role: 'G20 Director, MEWA',
    },
    {
        quote: 'Rens has a unique mix of a sharp strategic IQ with performance psychology. He received the highest ratings from our commercial team during our training days, and he helped shape our value propositioning. Highly recommend working with Rens!',
        name: 'Steven Rutgers',
        role: 'CCO, Arianespace',
    },
    {
        quote: 'Rens is the consummate business consulting professional with expertise in and passion for the work that he does. Excellent facilitator and strategist.',
        name: 'Evelyn Doyle',
        role: 'Head of People & Culture at Patagonia',
    },
    {
        quote: 'Rens has systematically and effectively implemented the best of positive psychology in a number of settings, from elite sports to corporate teams. My hope is that many more individuals, teams and organisations will benefit from his important work in the near future.',
        name: 'Tal Ben-Shahar',
        role: 'Harvard',
    },
    {
        quote: 'Rens led around 20 advanced negotiations workshops for our clients. The average score over all workshops was 9,5/10. Definitely recommended!',
        name: 'Mytte Staps',
        role: 'Better Minds',
    },
    {
        quote: 'Rens’s reputation preceded him. Before our first encounter I’d heard positive things about him, his work and his company. Rens played a key role in the success and growth of the team in the 2013–2014 season. For his effort and work I have the greatest respect and feel honoured to have worked with him.',
        name: 'Russell Garcia',
        role: 'HC Bloemendaal',
    },
    {
        quote: 'Rens has made the team more conscious of their strengths and the power of their (sometimes unconscious) beliefs. He has introduced practical ways to change our performance in a positive way.',
        name: 'Alex Pastoor',
        role: 'SBV Excelsior',
    },
    {
        quote: 'In 2013, I led a team of six to cross the Atlantic Ocean by kiteboard. When facing one of the heaviest setbacks in our preparations, Rens came to support us… Within two days Rens had set the stage for our team spirit to sort itself out — and regain the confidence needed to cross the ocean. ',
        name: 'Filippo Hellenberg-Hubar',
        role: 'HTC Kite Challenge',
    },
];

const Footer = () => {
    const shuffledTestimonials = [...testimonials].sort(() => Math.random() - 0.5);

    return (
        <footer className="w-full px-8 py-4 lg:px-20 py-10">
            <Swiper
                slidesPerView={1.2}
                spaceBetween={20}
                breakpoints={{
                    640: { slidesPerView: 1.5 },
                    768: { slidesPerView: 2.2 },
                    1024: { slidesPerView: 3 },
                }}
                loop={true}
                autoplay={{ delay: 3000 }}
                modules={[Pagination, Autoplay]}
                className="px-10"
            >
                {shuffledTestimonials.map((testimonial, index) => (
                    <SwiperSlide key={index}>
                        <div className="p-6 border border-grey bg-[#121212] text-white">
                            <p className="text-gray-300 text-sm xl:text-md">{testimonial.quote}</p>
                            <h4 className="mt-4 font-bold text-sm xl:text-md">{testimonial.name}</h4>
                            <p className="text-gray-400 text-xs xl:text-sm">{testimonial.role}</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </footer>
    );
};

export default Footer;
